var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.797,
    height: 17.799,
    viewBox: "0 0 29.797 17.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-panel",
    transform: "translate(-995 -1091.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(1014.787 1094.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1021.684,1106.6a1.112,1.112,0,0,1-.6-.176l-7.785-4.99a1.113,1.113,0,0,1,0-1.873l7.785-4.99a1.112,1.112,0,1,1,1.2,1.872l-6.324,4.055,6.324,4.053a1.112,1.112,0,0,1-.6,2.049Z",
    transform: "translate(-1012.788 -1094.397)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(995 1091.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1015.809,1094.109h-19.7a1.112,1.112,0,1,1,0-2.225h19.7a1.112,1.112,0,0,1,0,2.225Z",
    transform: "translate(-995 -1091.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(995 1099.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1010.574,1101.109H996.112a1.112,1.112,0,1,1,0-2.225h14.461a1.112,1.112,0,1,1,0,2.225Z",
    transform: "translate(-995 -1098.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(995 1107.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1015.809,1108.109h-19.7a1.112,1.112,0,1,1,0-2.225h19.7a1.112,1.112,0,0,1,0,2.225Z",
    transform: "translate(-995 -1105.884)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePanel);
export default __webpack_public_path__ + "static/media/close-panel.7215b26e941ae06027aaf3fb86a7db68.svg";
export { ForwardRef as ReactComponent };